import React from "react";
import { Field, Textarea, Text, Divider } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";

import EditableStringList from "../common/EditableStringList";
import "../../CSS/IaAgent.css";

const ERROR_KEYS = ["userNotFound", "transferFailed", "technicalError", "timeout"];

export default function SecurityErrorsTab({ agentData, updateField }) {
  const { t } = useTranslation();
  const securityRules = agentData.securityRules || [];
  const errorMessages = agentData.errorHandling?.errorMessages || {};

  return (
    <div className="ia-agent-tab">
      <Text size={500} weight="semibold" style={{ display: "block", marginBottom: 8 }}>
        {t("SECURITY_RULES_TITLE")}
      </Text>
      <Text size={200} style={{ color: "#666", display: "block", marginBottom: 12 }}>
        {t("SECURITY_RULES_HINT")}
      </Text>
      <EditableStringList
        label=""
        value={securityRules}
        onChange={(list) => updateField("securityRules", list)}
        placeholder={t("SECURITY_RULE_PLACEHOLDER")}
      />

      <Divider style={{ margin: "24px 0" }} />

      <Text size={500} weight="semibold" style={{ display: "block", marginBottom: 8 }}>
        {t("ERROR_MESSAGES_TITLE")}
      </Text>
      <Text size={200} style={{ color: "#666", display: "block", marginBottom: 12 }}>
        {t("ERROR_MESSAGES_HINT")}
      </Text>

      {ERROR_KEYS.map((key) => (
        <Field key={key} label={t(`ERROR_MSG_${key.toUpperCase()}`)} className="field-style">
          <Textarea
            value={errorMessages[key] || ""}
            onChange={(_, d) =>
              updateField("errorHandling.errorMessages", {
                ...errorMessages,
                [key]: d.value,
              })
            }
            placeholder={t(`ERROR_MSG_${key.toUpperCase()}_PLACEHOLDER`)}
            rows={2}
            resize="vertical"
          />
        </Field>
      ))}
    </div>
  );
}
